import React from 'react';
import PropTypes from 'prop-types';
import Switch from './Switch';
import { calculateNumberOfColumns } from '../categoryData';
import * as Common from './Common.styles';
import * as Styled from './Table.styles';

var renderTHead = function renderTHead(data, unit) {
  return /*#__PURE__*/React.createElement("thead", null, data.columns.map(function (column, trIndex) {
    return /*#__PURE__*/React.createElement(Styled.TableRow, {
      key: trIndex
    }, column.map(function (header, thIndex) {
      var value;
      var rowSpan;
      var colSpan;

      if (typeof header === 'string') {
        value = header;
      } else {
        value = typeof header.value === 'string' ? header.value : header.value[unit];
        rowSpan = header.rowSpan;
        colSpan = header.colSpan;
      }

      return /*#__PURE__*/React.createElement(Styled.TableHeader, {
        key: thIndex,
        scope: "col",
        rowSpan: rowSpan,
        colSpan: colSpan
      }, value);
    }));
  }));
};

var renderTBody = function renderTBody(data, unit) {
  return /*#__PURE__*/React.createElement("tbody", null, data.rows.map(function (_ref, trIndex) {
    var values = _ref.values;
    return /*#__PURE__*/React.createElement(Styled.TableRow, {
      key: trIndex
    }, values.map(function (_ref2, tdIndex) {
      var measurement = _ref2.measurement,
          header = _ref2.header,
          rowSpan = _ref2.rowSpan;
      var value = measurement.size || measurement[unit];
      return header === true ? /*#__PURE__*/React.createElement(Styled.TableHeader, {
        key: tdIndex,
        scope: "row"
      }, value) : /*#__PURE__*/React.createElement(Styled.TableData, {
        key: tdIndex,
        rowSpan: rowSpan
      }, value);
    }));
  }));
};

var Table = function Table(_ref3) {
  var title = _ref3.title,
      description = _ref3.description,
      id = _ref3.id,
      wide = _ref3.wide,
      data = _ref3.data,
      unit = _ref3.unit,
      unitToggle = _ref3.unitToggle,
      onUnitToggle = _ref3.onUnitToggle;
  return /*#__PURE__*/React.createElement(React.Fragment, null, (title || unitToggle) && /*#__PURE__*/React.createElement(Common.Header, {
    heading: !!title
  }, title && /*#__PURE__*/React.createElement(Common.Heading, null, title), unitToggle && /*#__PURE__*/React.createElement(Switch, {
    tableId: id,
    unit: unit,
    onChange: onUnitToggle
  })), description && /*#__PURE__*/React.createElement(Common.Description, null, description), /*#__PURE__*/React.createElement(Styled.TableWrapper, null, /*#__PURE__*/React.createElement(Styled.Table, {
    key: id,
    id: id,
    numberOfColumns: calculateNumberOfColumns(data.columns),
    wide: wide
  }, renderTHead(data, unit), renderTBody(data, unit))));
};

Table.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  wide: PropTypes.bool,
  data: PropTypes.shape({
    columns: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
      rowSpan: PropTypes.number,
      colSpan: PropTypes.number,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
        inch: PropTypes.string,
        cm: PropTypes.string
      })])
    })]))),
    rows: PropTypes.arrayOf(PropTypes.shape({
      rowSpan: PropTypes.number,
      values: PropTypes.arrayOf(PropTypes.shape({
        header: PropTypes.bool,
        measurement: PropTypes.oneOfType([PropTypes.shape({
          size: PropTypes.string
        }), PropTypes.shape({
          inch: PropTypes.string,
          cm: PropTypes.string
        })])
      }))
    }))
  }).isRequired,
  unit: PropTypes.oneOf(['cm', 'inch']),
  unitToggle: PropTypes.bool,
  onUnitToggle: PropTypes.func
};
Table.defaultProps = {
  wide: false,
  unit: 'cm',
  unitToggle: true,
  onUnitToggle: function onUnitToggle() {}
};
export default Table;